import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const newArrivals = [
  {
    id: 1,
    title: 'Premium Basmati Rice',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
    description: 'Newly imported, aged Basmati rice from the foothills of Himalayas'
  },
  {
    id: 2,
    title: 'Organic Spice Collection',
    image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
    description: 'Handpicked organic spices from Kerala'
  },
  {
    id: 3,
    title: 'Fresh Indian Snacks',
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
    description: 'Authentic Indian snacks made fresh daily'
  }
];

export default function Carousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <div className="relative">
      <Slider {...settings}>
        {newArrivals.map((item) => (
          <div key={item.id} className="relative h-[500px]">
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
              <div className="text-center text-white px-4">
                <h2 className="text-4xl font-bold mb-4">{item.title}</h2>
                <p className="text-xl">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}